import moment from "moment";

export const getInitials = (name) => {
  if (typeof name !== "string" || !name.trim()) return null;

  const nameParts = name.trim().split(" ");
  if (nameParts) {
    const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
    return initials.toUpperCase();
  } else {
    return nameParts[0][0].toUpperCase();
  }
};


export const qs = (params) => {
  if (!params || typeof params !== "object") return "";
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${queryString}` : "";
};

export const formatDate = (date, format = "DD-MM-YYYY, hh:mm A") => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format(format);
};

export const formatePrice = (number) => {
  if (!number) return "$ 0";
  const formattedNumber = Number(Math.abs(number)).toFixed(2);
  return `$ ${formattedNumber}`
};

export const getFilenameFromContentDisposition = (
  contentDisposition,
  fallback = "download.xlsx",
) => {
  if (!contentDisposition) return fallback;

  const utf8Match = contentDisposition.match(
    /filename\*\s*=\s*UTF-8''([^;\n]+)/i,
  );
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^["']|["']$/g, ""));
    } catch (error) {
      return utf8Match[1].trim().replace(/^["']|["']$/g, "");
    }
  }

  const quotedMatch = contentDisposition.match(/filename\s*=\s*"([^"]+)"/i);
  if (quotedMatch?.[1]) {
    return quotedMatch[1].trim();
  }

  const plainMatch = contentDisposition.match(/filename\s*=\s*([^;\n]+)/i);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim().replace(/^["']|["']$/g, "");
  }

  return fallback;
};

// Browsers truncate <a download> filenames at "@", which also drops the extension.
export const sanitizeExcelDownloadFilename = (fileName) => {
  let name = String(fileName || "download").trim();
  name = name.replace(/@/g, "_at_");
  name = name.replace(/[\\/:*?"<>|]+/g, "_");
  if (!/\.xlsx$/i.test(name)) {
    name = `${name.replace(/\.+$/, "")}.xlsx`;
  }
  return name;
};

export const getDownloadFilenameFromResponse = (response, fallback) => {
  const headers = response?.headers;
  let contentDisposition = "";

  if (headers) {
    if (typeof headers.get === "function") {
      contentDisposition =
        headers.get("content-disposition") ||
        headers.get("Content-Disposition") ||
        "";
    }

    if (!contentDisposition) {
      const matched = Object.entries(headers).find(
        ([key]) => String(key).toLowerCase() === "content-disposition",
      );
      contentDisposition = matched?.[1] || "";
    }
  }

  return sanitizeExcelDownloadFilename(
    getFilenameFromContentDisposition(contentDisposition, fallback),
  );
};

export const getIBHierarchyReportFallbackName = ({
  salesAgentEmail,
  email,
} = {}) => {
  if (salesAgentEmail) {
    return `IB_Hierarchy_Commission_Lots_SalesAgent_${salesAgentEmail}`;
  }
  if (email) {
    return `IB_Hierarchy_Commission_Lots_${email}`;
  }
  return "IB_Hierarchy_Commission_Lots";
};
